/**
 * @generated SignedSource<<1ddb88fa9139916889509c0cd8be93b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type card_workManagementBoard_CardCoverWrapper_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cardCover_workManagementBoard_queryFragment">;
  readonly " $fragmentType": "card_workManagementBoard_CardCoverWrapper_queryFragment";
};
export type card_workManagementBoard_CardCoverWrapper_queryFragment$key = {
  readonly " $data"?: card_workManagementBoard_CardCoverWrapper_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"card_workManagementBoard_CardCoverWrapper_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "card_workManagementBoard_CardCoverWrapper_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "cardCover_workManagementBoard_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "8c84364e81d848df94dc44aa73e443dd";

export default node;
